import { useEffect, useSyncExternalStore } from 'react';
import { gql } from './client';

export const TOKEN_DISCLAIMER =
  'Tokens are provided free of charge, have no cash value and cannot be exchanged, transferred or refunded for money. Elevations Planning is provided "as is" without warranty of any kind, and assessments are not professional planning, legal or financial advice.';

interface WalletState { balance: number | null; error: string | null }

let state: WalletState = { balance: null, error: null };
const listeners = new Set<() => void>();
let inFlight: Promise<void> | null = null;

function setState(next: WalletState) {
  state = next;
  listeners.forEach(l => l());
}

export function refreshWallet(): Promise<void> {
  if (inFlight) return inFlight;
  inFlight = gql<{ elevationsPlanningTokenWallets: { id: string; balance: number }[] | null }>(
    'query TokenWallet { elevationsPlanningTokenWallets { id balance } }',
  )
    .then(d => setState({ balance: d.elevationsPlanningTokenWallets?.[0]?.balance ?? 0, error: null }))
    .catch((e: Error) => setState({ balance: state.balance, error: e.message }))
    .finally(() => { inFlight = null; });
  return inFlight;
}

export function useTokenWallet(): { balance: number | null; error: string | null; refresh: () => Promise<void> } {
  const snap = useSyncExternalStore(
    cb => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => state,
  );
  useEffect(() => { if (state.balance === null && !inFlight) void refreshWallet(); }, []);
  return { balance: snap.balance, error: snap.error, refresh: refreshWallet };
}
